import { StatePreV4, StateV4 } from './4_migrate_remove_obsolete_produktauswahl.interfaces';

export const migrateRemoveObsoleteProduktauswahl = (
  previousState: StatePreV4,
  newVersion: number,
): StateV4 => {
  const newState = {
    ...previousState,
  };
  delete newState.produktauswahl;
  return {
    ...newState,
    version: newVersion,
  };
};
